import { render, staticRenderFns } from "./ReplaceCard.vue?vue&type=template&id=e8aff22e"
import script from "./ReplaceCard.vue?vue&type=script&lang=js"
export * from "./ReplaceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports